import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss'],
  standalone: true
})
export class CallbackComponent implements OnInit {

  constructor(private readonly router: Router) { }

  ngOnInit(): void {
    this.handleAuthCallback();
  }

  private handleAuthCallback(): void {
    try {
      // Extract the fragment (everything after #)
      const fragment = globalThis.location.hash.substring(1);

      if (!fragment) {
        console.error('No fragment found in URL');
        this.router.navigate(['/login']);
        return;
      }

      const params = new URLSearchParams(fragment);
      const idToken = params.get('id_token');

      if (idToken) {
        window.open(`${environment.redirectUrl}/${idToken}`, "_self");
      } else {
        console.error('No id_token found in callback URL');
        this.router.navigate(['/login']);
      }
    } catch (error) {
      console.error('Error parsing callback:', error);
      this.router.navigate(['/login']);
    }
  }
}

